import PropTypes from 'prop-types';
import React from 'react';

import Box          from '@mui/material/Box';
import Typography   from '@mui/material/Typography';
import Button       from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import Grid         from '@mui/material/Grid';

import ArrowForwardIcon         from '@mui/icons-material/ArrowForward';
import LocationOnIcon           from '@mui/icons-material/LocationOn';
import WorkIcon                 from '@mui/icons-material/Work';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

function List({ campaigns }) {

  const theme = useTheme();

  function Campaign ({ campaign }) {
    return (
      <Box sx={{ backgroundColor: theme.palette.grey['100'], p: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="p" sx={{ fontWeight: 'bold' }} data-testid="title">{campaign.publicJobTitle()}</Typography>
          </Box>

          <Button
            variant="outlined"
            color="primary"
            href={`${campaign.jobLandingPageUrl}?source=${t('eos.company.listings.page.source')}`}
            target="_blank"
            data-testid="apply-button"
          >
            <Typography variant="p">{t('eos.company.listings.page.button.apply')}</Typography>
            <ArrowForwardIcon color="primary" sx={{ pl: 1 }} />
          </Button>
        </Box>

        <Box sx={{ display: 'flex' }}>
          <Grid container spacing={2} columns={8} sx={{ pb: 1, display: { xs: 'flex', md: 'none' }}}>
            <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
              <LocationOnIcon sx={{ fontSize: 15, fontWeight: 100 }} />
              <Typography variant="caption" sx={{ fontStyle: 'italic', pr: 2, pl: 0.5, fontWeight: 'light' }}>{campaign.cityLocation()}</Typography>
            </Grid>

            <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
              <WorkIcon sx={{ fontSize: 15, fontWeight: 100 }} />
              <Typography variant="caption" sx={{ fontStyle: 'italic', pr: 2, pl: 0.5, fontWeight: 'light' }}>{campaign.jobTypeTitle()}</Typography>
            </Grid>

            <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
              <AccountBalanceWalletIcon sx={{ fontSize: 15, fontWeight: 100 }} />
              <Typography variant="caption" sx={{ fontStyle: 'italic', pr: 2, pl: 0.5, fontWeight: 'light' }}>{campaign.salaryValue()}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} columns={8} sx={{ pb: 1,  display: { xs: 'none', md: 'flex' }}}>
            <Grid item md={8} sx={{ display: 'flex', alignItems: 'center' }}>
              <LocationOnIcon sx={{ fontSize: 15, fontWeight: 100 }} />
              <Typography variant="caption" sx={{ fontStyle: 'italic', pr: 2, pl: 0.5, fontWeight: 'light' }} data-testid="location">{campaign.cityLocation()}</Typography>

              <WorkIcon sx={{ fontSize: 15, fontWeight: 100 }} />
              <Typography variant="caption" sx={{ fontStyle: 'italic', pr: 2, pl: 0.5, fontWeight: 'light' }} data-testid="job-type">{campaign.jobTypeTitle()}</Typography>

              <AccountBalanceWalletIcon sx={{ fontSize: 15, fontWeight: 100 }} />
              <Typography variant="caption" sx={{ fontStyle: 'italic', pr: 2, pl: 0.5, fontWeight: 'light' }} data-testid="salary">{campaign.salaryValue()}</Typography>
            </Grid>
          </Grid>
        </Box>

        <Typography sx={{ pt: 1 }} data-testid="description">{campaign.briefValue()}</Typography>
      </Box>
    );
  }

  return (
    <>
      { campaigns.map((campaign) => <Campaign campaign={campaign} key={campaign.id} />) }
    </>
  );
}

List.defaultProps = {
  campaigns: [],
};

List.propTypes = {
  campaign: PropTypes.array,
};

export default List;
